import { Col, Container, Row } from "react-bootstrap";
import PageHeader from "../../components/pageHeader";
import GraphView from "./components/graphView";
import DigitalTwinCard from "./components/digitalTwinCard";
import PurchaseCard from "./components/purchaseCard";
import "./style.scss"
import SensorTable from "./components/sensorTable";
import data from "./components/sensorData.json"
import { useParams } from "react-router-dom";

const MeasurementDetails = () => {
  const { id }:any = useParams(); 
  const decodedId = decodeURIComponent(id);
  console.log("========>",decodedId)
  return (
    <main>
      <Container fluid>
        <PageHeader
          title={` D-Twin ID: S-90240-00039`}
          breadcum={
            "Dashboard / Applications / Measurements / Measurement Warnings"
          }
        ></PageHeader>
        <Row className="mb-5">
          <Col   md={8} className="">
           <GraphView />
          </Col>
          <Col md={4} className="d-flex flex-column justify-content-between">
          <Row>
            <Col><DigitalTwinCard id={decodedId} /></Col>
          </Row>
          <Row>
            <Col><PurchaseCard /></Col>
          </Row>
            
          </Col>
        </Row>
        <Row>
        <Col   md={8} className="">
           <SensorTable data = {data}/>
          </Col>
          <Col md={4}></Col>
        </Row>
      </Container>
    </main>
  );
};

export default MeasurementDetails;
